import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultarMunicipios } from './types';

export const INITIAL_STATE: ConsultarMunicipios = {
	status: 0,
	data: null,
	totalRegistrosConsulta: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarMunicipios {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_MUNICIPIOS_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CONSULTAR_MUNICIPIOS_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				draft.totalRegistrosConsulta =
					action.payload.headers['total-num-registros'];
				break;
			}

			case Types.CONSULTAR_MUNICIPIOS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_MUNICIPIOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
	});
}
